// Firestore collection/path helpers (all data scoped under users/{uid}/...)
// These are strings only; use with Firebase modular SDK collection()/doc().

export const userPath = (uid) => `users/${uid}`;
export const incomePath = (uid) => `${userPath(uid)}/income`;
export const expensesPath = (uid) => `${userPath(uid)}/expenses`;
export const shoppingListsPath = (uid) => `${userPath(uid)}/shoppingLists`;
export const shoppingListItemsPath = (uid, listId) => `${shoppingListsPath(uid)}/${listId}/items`;
export const savingsGoalsPath = (uid) => `${userPath(uid)}/savingsGoals`;
export const savingsTransactionsPath = (uid) => `${userPath(uid)}/savingsTransactions`;
export const budgetsPath = (uid) => `${userPath(uid)}/budgets`;
export const todosPath = (uid) => `${userPath(uid)}/todos`;
export const insightSnapshotsPath = (uid) => `${userPath(uid)}/insightSnapshots`;

// Helper to get a doc path for commonly linked records
export const shoppingItemDocPath = (uid, listId, itemId) => `${shoppingListItemsPath(uid, listId)}/${itemId}`;
export const expenseDocPath = (uid, expenseId) => `${expensesPath(uid)}/${expenseId}`;
export const savingsGoalDocPath = (uid, goalId) => `${savingsGoalsPath(uid)}/${goalId}`;
export const budgetDocPath = (uid, periodId) => `${budgetsPath(uid)}/${periodId}`;
export const todoDocPath = (uid, todoId) => `${todosPath(uid)}/${todoId}`;
